module.exports = __webpack_public_path__ + "img/the_2021_mirage_collection.1b1a1508.png";